module.exports = __webpack_public_path__ + "static/Inari-Otonkoski-4f9b8a78f47051fc204e10c4e1ce810a.jpg";